import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getUserInfo } from "../actions/inquires";
import { appointementUser } from "../actions/appointement";

import GoogleMap from './components/GoogleMap';

class ClassMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: this.props.restIntel.intel.dealerInfo.lat,
        lng: this.props.restIntel.intel.dealerInfo.lng,
      },
      isMarkerShown:false
    }

  }
  delayedShowMarker = ()=>{
    setTimeout(()=>{
      this.setState({isMarkerShown : true});
    }, 0);
  }
  componentDidMount(){
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/model_choice'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
    this.delayedShowMarker()
  }
  render() {
    return (
      <div className="googlemap">
        <GoogleMap
          center={this.state.center}
          isMarkerShown={this.state.isMarkerShown}
          containerElement={{ height: '100%' }}
          mapElement={{ height: '100%' }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getUserInfo,
      appointementUser
    },
    dispatch
  );

export const PageMap = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassMap);






// WEBPACK FOOTER //
// ./src/containers/PageMap.js